<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información del tipo de descuento</h1>
    <div class="information" v-if="type">
      <p v-if="type.name" class="information__text"><strong class="information__text--strong">Nombre: </strong>{{type.name}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Object
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/discount_types/view.vue